import { createSelector } from '@ngrx/store'
import { AppState } from '../index'
import { UserRoles } from './../../../admin/model/admin.model'
import { ADMIN_VIEWER } from '../../../structured-credit/models/structured-credit.models'

export const selectAuthState = (state: AppState) => state.auth

export const selectCarriers = createSelector(selectAuthState, (state) => state.carriers)

export const selectStudies = createSelector(selectAuthState, (state) => state.studies)

export const selectSageLogicalRole = createSelector(
  selectAuthState,
  (state) => state.sageLogicalRole,
)

export const selectFeatureFlags = createSelector(selectAuthState, (state) => state.featureFlags)

export const selectUserName = createSelector(selectAuthState, (state) => state.username)

export const selectCreditReinsurer = createSelector(
  selectAuthState,
  (state) => state?.creditReinsurer,
)

/**
 * if user is a client, they will only have one carrier, so return it
 */
export const selectAssignedClientId = createSelector(
  selectSageLogicalRole,
  selectCarriers,
  (sageLogicalRole, carriers) => {
    return sageLogicalRole === UserRoles.Client ? carriers.at(0)?.id : null
  },
)

export const selectIsStructuredCreditReadOnly = createSelector(
  selectSageLogicalRole,
  (sageLogicalRole) =>
    sageLogicalRole !== UserRoles.Contractor && sageLogicalRole !== UserRoles.Broker,
)

// Returned when a Reinsurer's identity hasn't loaded/assigned yet. Never null -- null means
// "no lock" (Contractor/Broker) and would incorrectly unlock viewer switching plus the
// ADMIN_VIEWER (all-panel) aggregate view for this user. Never matches a real reinsurer_id or
// ADMIN_VIEWER, so it also locks out all deal/transaction visibility until a real id arrives.
export const UNASSIGNED_REINSURER_LOCK = '__unassigned-reinsurer__'

export const selectStructuredCreditViewerLock = createSelector(
  selectSageLogicalRole,
  selectCreditReinsurer,
  (sageLogicalRole, creditReinsurer) => {
    if (sageLogicalRole === UserRoles.Reinsurer) {
      return creditReinsurer?.reinsurerId != null
        ? String(creditReinsurer.reinsurerId)
        : UNASSIGNED_REINSURER_LOCK
    }
    if (sageLogicalRole === UserRoles.Client) {
      return ADMIN_VIEWER
    }
    return null
  },
)
